import React, { useEffect, useState } from "react"
import { db } from "../../Firebase/config"
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  query,
  orderBy,
  writeBatch,
  where,
} from "firebase/firestore"
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd"

export default function CategoriesManager() {
  const [categories, setCategories] = useState([])

  const fetchCategories = async () => {
    const colRef = collection(db, "Categories")

    const snapshot = await getDocs(colRef)

    const fetched = snapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }))

    const sortedCategories = fetched.sort((a, b) => {
      const aOrder = Number(a.order)
      const bOrder = Number(b.order)

      const aHasOrder = Number.isFinite(aOrder)
      const bHasOrder = Number.isFinite(bOrder)

      // Both have order → sort normally
      if (aHasOrder && bHasOrder) {
        return aOrder - bOrder
      }

      // Only A has order → A comes first
      if (aHasOrder && !bHasOrder) {
        return -1
      }

      // Only B has order → B comes first
      if (!aHasOrder && bHasOrder) {
        return 1
      }

      // Neither has order → keep original order
      return 0
    })

    setCategories(sortedCategories)
  }

  useEffect(() => {
    fetchCategories()
  }, [])

  const handleDragEnd = async (result) => {
    const { source, destination } = result

    if (!destination || source.index === destination.index) return

    const newCategories = Array.from(categories)
    const [movedItem] = newCategories.splice(source.index, 1)
    newCategories.splice(destination.index, 0, movedItem)

    setCategories(newCategories)

    // Update Firestore order field
    for (let i = 0; i < newCategories.length; i++) {
      const catRef = doc(db, "Categories", newCategories[i].id)
      await updateDoc(catRef, { order: i })
    }
  }

  const handleDelete = async (categoryId) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this category and all its products?",
    )
    if (!confirm) return

    const batch = writeBatch(db)

    // Delete the category itself
    const catRef = doc(db, "Categories", categoryId)
    batch.delete(catRef)

    // Get and delete all associated products
    const productsRef = collection(db, "Products")
    const q = query(productsRef, where("CategoryId", "==", categoryId))
    const snapshot = await getDocs(q)

    snapshot.forEach((docSnap) => {
      batch.delete(doc(db, "Products", docSnap.id))
    })

    await batch.commit()
    await fetchCategories()
  }

  return (
    <div style={{ padding: "2rem", maxWidth: "500px", margin: "0 auto" }}>
      <h2 style={{ textAlign: "center" }}>Manage Categories</h2>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="categories" direction="vertical">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {categories.map((category, index) => (
                <Draggable
                  key={category.id}
                  draggableId={category.id}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        background: "#f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                        userSelect: "none",
                        fontSize: "16px",
                        fontWeight: "500",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        ...provided.draggableProps.style,
                      }}
                    >
                      <div>
                        <div>{category.name || "No Name"}</div>
                      </div>

                      <button
                        onClick={() => handleDelete(category.id)}
                        style={{
                          background: "#ff4d4f",
                          border: "none",
                          color: "white",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  )
}
